<div class="resend-email-page">
  <!-- Arrière-plan animé -->
  <div class="animated-background">
    <!-- Cercles décoratifs -->
    <div class="decorative-circles">
      <div class="circle circle-1"></div>
      <div class="circle circle-2"></div>
      <div class="circle circle-3"></div>
      <div class="circle circle-4"></div>
    </div>

    <!-- Particules lumineuses -->
    <div class="light-particles">
      <div class="light-particle particle-1"></div>
      <div class="light-particle particle-2"></div>
      <div class="light-particle particle-3"></div>
      <div class="light-particle particle-4"></div>
      <div class="light-particle particle-5"></div>
      <div class="light-particle particle-6"></div>
    </div>

    <!-- Icônes flottantes -->
    <div class="floating-icons">
      <i class="fas fa-envelope icon-1"></i>
      <i class="fas fa-paper-plane icon-2"></i>
      <i class="fas fa-redo icon-3"></i>
      <i class="fas fa-envelope-open icon-4"></i>
    </div>
  </div>

  <div class="container resend-container">
    <div class="row justify-content-center align-items-center min-vh-100">
      <div class="col-lg-5 col-md-7 col-sm-9">

        <!-- État : Formulaire de renvoi -->
        <div class="resend-card card-custom fade-in-up" *ngIf="!emailSent">
          <div class="text-center mb-4">
            <div class="icon-wrapper mb-3">
              <i class="fas fa-paper-plane"></i>
            </div>
            <h1 class="mb-2">Renvoyer l'email de vérification</h1>
            <p class="text-secondary">
              Entrez votre adresse email pour recevoir un nouveau lien d'activation
            </p>
          </div>

          <!-- Message d'erreur global -->
          <div class="alert alert-danger alert-dismissible fade show mb-4" role="alert" *ngIf="errorMessage">
            <i class="fas fa-exclamation-circle me-2"></i>
            {{ errorMessage }}
            <button type="button" class="btn-close" (click)="errorMessage = ''"></button>
          </div>

          <!-- Formulaire -->
          <form [formGroup]="resendForm" (ngSubmit)="onSubmit()">
            <!-- Email -->
            <div class="form-group mb-4">
              <label for="email" class="form-label">
                Adresse email <span class="text-danger">*</span>
              </label>
              <div class="input-wrapper">
                <i class="input-icon fas fa-envelope"></i>
                <input
                  type="email"
                  id="email"
                  class="form-control custom-input"
                  placeholder="contact@example.com"
                  formControlName="email"
                  [class.is-invalid]="isFieldInvalid('email')"
                />
              </div>
              <div class="invalid-feedback" *ngIf="isFieldInvalid('email')">
                {{ getFieldError('email') }}
              </div>
            </div>

            <!-- Info box -->
            <div class="info-box mb-4">
              <i class="fas fa-info-circle text-primary-color me-2"></i>
              <small>
                Nous vous enverrons un email avec un nouveau lien d'activation valable 24 heures
              </small>
            </div>

            <!-- Bouton d'envoi -->
            <button
              type="submit"
              class="btn btn-primary-custom w-100 mb-3"
              [disabled]="loading"
            >
              <span *ngIf="!loading">
                <i class="fas fa-paper-plane me-2"></i>
                Envoyer le lien
              </span>
              <span *ngIf="loading" class="d-flex align-items-center justify-content-center">
                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Envoi en cours...
              </span>
            </button>

            <!-- Liens -->
            <div class="text-center">
              <p class="mb-0 text-secondary">
                <a (click)="goToSignin()" class="text-primary-color cursor-pointer me-3">
                  <i class="fas fa-arrow-left me-1"></i>
                  Retour à la connexion
                </a>
                <a (click)="goToSignup()" class="text-primary-color cursor-pointer">
                  <i class="fas fa-user-plus me-1"></i>
                  Créer un compte
                </a>
              </p>
            </div>
          </form>

          <!-- Instructions -->
          <div class="instructions-section mt-4">
            <h6 class="instructions-title mb-3">
              <i class="fas fa-lightbulb text-primary-color me-2"></i>
              Conseils utiles
            </h6>
            <ul class="instructions-list">
              <li>Vérifiez votre dossier spam si vous ne recevez pas l'email</li>
              <li>Le lien d'activation expire après 24 heures</li>
              <li>Assurez-vous d'utiliser la même adresse email que lors de l'inscription</li>
            </ul>
          </div>
        </div>

        <!-- État : Email envoyé avec succès -->
        <div class="resend-card card-custom fade-in-up text-center" *ngIf="emailSent">
          <div class="success-icon-wrapper mb-4">
            <i class="fas fa-check-circle"></i>
            <div class="success-particles">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>

          <h1 class="mb-3">Email envoyé !</h1>
          <p class="text-secondary mb-4">
            Un nouveau lien d'activation a été envoyé à
            <br>
            <strong class="text-primary-color">{{ resendForm.get('email')?.value }}</strong>
          </p>

          <!-- Instructions -->
          <div class="success-instructions mb-4">
            <h6 class="mb-3">
              <i class="fas fa-list-check text-primary-color me-2"></i>
              Prochaines étapes
            </h6>
            <ol class="text-start">
              <li class="mb-2">Consultez votre boîte de réception</li>
              <li class="mb-2">Cliquez sur le lien d'activation dans l'email</li>
              <li class="mb-2">Votre compte sera activé immédiatement</li>
              <li>Connectez-vous et profitez de nos services</li>
            </ol>
          </div>

          <!-- Alert info -->
          <div class="alert alert-info mb-4" role="alert">
            <i class="fas fa-clock me-2"></i>
            <small>Le lien d'activation est valable pendant 24 heures</small>
          </div>

          <!-- Message de redirection -->
          <div class="redirect-message mb-4">
            <i class="fas fa-info-circle text-primary-color me-2"></i>
            <small class="text-secondary">Redirection automatique vers la connexion...</small>
          </div>

          <!-- Bouton d'action -->
          <button class="btn btn-primary-custom" (click)="goToSignin()">
            <i class="fas fa-sign-in-alt me-2"></i>
            Aller à la connexion
          </button>
        </div>

        <!-- Section aide -->
        <div class="help-section text-center mt-4 fade-in">
          <p class="text-secondary small mb-2">
            <i class="fas fa-question-circle me-1"></i>
            Vous ne recevez pas l'email ?
          </p>
          <div class="help-links">
            <a routerLink="/contact" class="text-primary-color me-3">
              <i class="fas fa-life-ring me-1"></i>
              Support
            </a>
            <a routerLink="/faqs" class="text-primary-color me-3">
              <i class="fas fa-question me-1"></i>
              FAQ
            </a>
            <a routerLink="/contact" class="text-primary-color">
              <i class="fas fa-envelope me-1"></i>
              Contact
            </a>
          </div>
        </div>

      </div>
    </div>
  </div>

  <footer class="resend-footer">
    <div class="container">
      <p class="text-center text-secondary small mb-0">
        © {{ currentYear }} SappTradingPro. Tous droits réservés.
      </p>
    </div>
  </footer>
</div>
